import { createContext, useContext } from 'react';

export const PageTransitionContext = createContext(null);

export const useTransition = () => useContext(PageTransitionContext);